import React from "react";
import { Dialog } from "@headlessui/react";
import Button from "../../../ui/Button";

interface PrintBarcodeOrBatchModalProps {
  manufacturedProductId: any;
  setOpen?: (open: any) => void;
  getManufacturedProductLabel?: (id: any) => Promise<void> | void;
  printProductionCostReport?: () => Promise<void> | void;
  getProductionBatchReport?: (id: any) => Promise<void> | void;
  getLabelCheckReport?: (id: any) => Promise<void> | void;
  getVacuumPackReport?: (id: any) => Promise<void> | void;
  getCookingAndCoolingReport?: (id: any) => Promise<void> | void;
  getMetalDetectorReport?: (id: any) => Promise<void> | void;
  openNitrateAndPhosphateCalculator?: () => void;
  getCookingAndDryingReport?: (id: any) => void;
}

export default function PrintBarcodeOrBatchModal(
  props: PrintBarcodeOrBatchModalProps,
) {
  const {
    manufacturedProductId,
    getManufacturedProductLabel,
    printProductionCostReport,
    getProductionBatchReport,
    getLabelCheckReport,
    getVacuumPackReport,
    getCookingAndCoolingReport,
    getMetalDetectorReport,
    openNitrateAndPhosphateCalculator,
  } = props;
  const [loadingReport, setLoadingReport] = React.useState<string | null>(null);

  const runReportAction = async (
    report: string,
    action: () => Promise<void> | void,
  ) => {
    setLoadingReport(report);
    try {
      await new Promise<void>((resolve) => setTimeout(resolve, 150));
      await action();
    } finally {
      setLoadingReport(null);
    }
  };

  return (
    <div>
      <div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-semibold leading-6 text-gray-900"
          >
            What would you like to open?
          </Dialog.Title>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          loading={loadingReport === "batch"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("batch", () =>
              getProductionBatchReport?.(manufacturedProductId),
            )
          }
        >
          Production Batch Report
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          loading={loadingReport === "tag"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("tag", () =>
              getManufacturedProductLabel?.(manufacturedProductId),
            )
          }
        >
          Production Tag
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          loading={loadingReport === "nitrate"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("nitrate", () =>
              openNitrateAndPhosphateCalculator?.(),
            )
          }
        >
          Nitrate & Phosphate Report
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          loading={loadingReport === "cooking"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("cooking", () =>
              getCookingAndCoolingReport?.(manufacturedProductId),
            )
          }
        >
          Cooking & Cooling
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          loading={loadingReport === "fermentation"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("fermentation", () =>
              getLabelCheckReport?.(manufacturedProductId),
            )
          }
        >
          Fermentation Record
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          loading={loadingReport === "label"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("label", () =>
              getLabelCheckReport?.(manufacturedProductId),
            )
          }
        >
          Label Check Report
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          loading={loadingReport === "vacuum"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("vacuum", () =>
              getVacuumPackReport?.(manufacturedProductId),
            )
          }
        >
          Vacuum Pack
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          loading={loadingReport === "metal"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("metal", () =>
              getMetalDetectorReport?.(manufacturedProductId),
            )
          }
        >
          Metal Detector
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          loading={loadingReport === "cost"}
          disabled={loadingReport !== null}
          onClick={() =>
            runReportAction("cost", () => printProductionCostReport?.())
          }
        >
          Production Cost Report
        </Button>
      </div>
    </div>
  );
}
